module.exports = __webpack_public_path__ + "static/media/IMG_1707.95b065bf.JPG";